module.exports = __webpack_public_path__ + "img/icon_setting_on.e66a00a6.svg";